<template>
    <div class="calculator">
        <div class="form-item" id="loan-amount">
            <label for="loan-amount">
                <span>Loan Amount $:</span>
                <span class="form-required" title="This field is required.">*</span>
            </label>
            <div class="form-field">
                <input type="number" v-model="sum" min="100" max="5000" step="100">
                <input type="range" min="100" max="5000" step="100" v-model="sum">
            </div>
        </div>

        <div class="form-item" id="loan-days">
            <label for="loan-days">
                <span>Loan Term (Days):</span>
                <span class="form-required" title="This field is required.">*</span>
            </label>
            <div class="form-field">
                <input type="number" v-model="days" min="1" max="31" step="1">
                <input type="range" min="1" max="31" step="1" v-model="days">
            </div>
        </div>

        <div class="form-item-flex">
            <div class="form-item" id="loan-percent">
                <label for="loan-percent">
                    <span>APR value %:</span>
                    <span class="form-required" title="This field is required.">*</span>
                </label>
                <div class="form-field">
                    <input type="number" v-model="percent" step="any">
                </div>
            </div>

            <div class="form-item" id="loan-fee">
                <label for="loan-fee">
                    <span>Origination Fee $:</span>
                    <span class="form-required" title="This field is required.">*</span>
                </label>
                <div class="form-field">
                    <input type="number" min="0" max="1000" step="any" v-model="fee">
                </div>
            </div>
        </div>

        <div class="results">
            <div class="calc-logo">
                <div class="result-amount">
                    <div class="result loan">
                        <span class="num">$<b>{{ sum }}</b></span>
                        <span class="act">Your loan</span>
                    </div>
                    <div class="result fee">
                        <span>+</span>
                        <span class="num">$<b>{{ overpayment + parseInt(fee) }}</b></span>
                        <span class="act">Your fee</span>
                    </div>
                    <div class="result total">
                        <span>=</span>
                        <span class="num">$<b>{{ result }}</b></span>
                        <span class="act value-label">Total Cost*</span>
                    </div>
                    <p class="small">* Total Cost - The sum of money you are to pay off within the term you’ve chosen if
                        you borrow the stated above amount for the average (or required by your lender) APR.</p>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CalcComponent",
    data() {
        return {
            "sum": 1000,
            "days": 7,
            "percent": 200,
            "fee": 0
        }
    },
    computed: {
        "overpayment": function () {
            return parseInt(parseInt(this.sum) * (((this.percent / 365) * this.days) / 100));
        },
        "result": function () {
            return Math.floor(this.overpayment + parseInt(this.sum) + parseInt(this.fee)).toLocaleString();
        }
    }
}
</script>

<style scoped>

.total .num {
    color: #56b90e;
}

p.small {
    font-size: 12px;
    color: #797979;
    margin: 0;
}

.result-amount span, .result-amount div {
    display: inline-block;
    vertical-align: top;
    margin: 0 0 0 0;
    font-weight: 600;
    font-size: 17px;
}

.result-amount span{
    margin: 0 4px 0 0;
}

.num {
    color: #00a5e0;
    margin: 10px;
}

.calc-logo {
   border-radius: 4px;
    border: 2px solid #00a5e0;
    padding: 10px;
}

.calc-logo p.small{
    background: url('data:image/svg+xml;utf8;base64,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') no-repeat 15px center;
    padding-left: 60px;
    padding-top: 10px;
}

.form-item-flex {
    display: flex;
}

.form-item label {
    display: block;
    font-weight: bold;
    font-size: 12px;
}

.form-field {
    display: flex;
    margin-bottom: 25px;
}

.form-required {
    color: #f00;
}

input[type="number"], input[type="text"] {
    border: 2px solid #dedede;
    padding: 8px;
    margin: 2px 0;
    border-radius: 3px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    width: 110px;
    margin-right: 15px;
}

input[type=range] {
    height: 25px;
    -webkit-appearance: none;
    margin: 10px 0;
    width: 100%;
    background: none;
    border: none;
}

input[type=range]:focus {
    outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000;
    background: #2497E3;
    border-radius: 1px;
    border: 0px solid #000000;
}

input[type=range]::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px #000000;
    border: 1px solid #2497E3;
    height: 18px;
    width: 18px;
    border-radius: 25px;
    background: #A1D0FF;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -7px;
}

input[type=range]:focus::-webkit-slider-runnable-track {
    background: #2497E3;
}

input[type=range]::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000;
    background: #2497E3;
    border-radius: 1px;
    border: 0px solid #000000;
}

input[type=range]::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000000;
    border: 1px solid #2497E3;
    height: 18px;
    width: 18px;
    border-radius: 25px;
    background: #A1D0FF;
    cursor: pointer;
}

input[type=range]::-ms-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    color: transparent;
}

input[type=range]::-ms-fill-lower {
    background: #2497E3;
    border: 0px solid #000000;
    border-radius: 2px;
    box-shadow: 0px 0px 0px #000000;
}

input[type=range]::-ms-fill-upper {
    background: #2497E3;
    border: 0px solid #000000;
    border-radius: 2px;
    box-shadow: 0px 0px 0px #000000;
}

input[type=range]::-ms-thumb {
    margin-top: 1px;
    box-shadow: 0px 0px 0px #000000;
    border: 1px solid #2497E3;
    height: 18px;
    width: 18px;
    border-radius: 25px;
    background: #A1D0FF;
    cursor: pointer;
}

input[type=range]:focus::-ms-fill-lower {
    background: #2497E3;
}

input[type=range]:focus::-ms-fill-upper {
    background: #2497E3;
}

</style>
